export const actorPhoneTypes = Object.freeze({
    business: 1,
    mobile: 2,
    home: 3,
    fax: 4
});